import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-900 mb-3">
          加入51吃瓜每日大赛
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 font-label">
          每日更新最热吃瓜爆料，不错过任何精彩大瓜
        </p>
        <Link
          to="/category/shishi-baoliao"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-secondary-500 hover:bg-secondary-600 text-white font-label text-sm rounded-full transition-colors whitespace-nowrap"
        >
          开始吃瓜 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 mt-12">
        <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap">
          {[
            { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20celebrity%20on%20red%20carpet%2C%20isolated%20cutout%20style%2C%20transparent%20background%20mimicking%2C%20clean%20white%20background%2C%20minimal%20design&width=200&height=120&seq=cta-img-1&orientation=landscape', alt: '明星爆料' },
            { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20influencer%20with%20phone%2C%20cutout%20style%2C%20clean%20white%20background%2C%20minimal%20design%2C%20social%20media%20theme&width=200&height=120&seq=cta-img-2&orientation=landscape', alt: '网红动态' },
            { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20business%20building%2C%20corporate%20cutout%20style%2C%20clean%20white%20background%2C%20minimal%20design&width=200&height=120&seq=cta-img-3&orientation=landscape', alt: '企业内幕' },
            { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20microphone%20and%20camera%2C%20media%20cutout%20style%2C%20clean%20white%20background%2C%20minimal%20design%2C%20news%20reporting%20theme&width=200&height=120&seq=cta-img-4&orientation=landscape', alt: '实时报道' },
          ].map((img, i) => (
            <div key={i} className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}